///
/// EarthBrowser
///
/// Migration v40 to v41: Add radar dataset visibility
/// Created by Matt Giger on 9/15/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v40 to v41
 *
 * Changes:
 * - The global radar mosaic gets its own "radar" entry in
 *   earthbrowser.visibleDatasets, split out of "precipitation" (which now
 *   covers only the IMERG satellite estimate). Users who had precipitation
 *   visible were seeing radar too, so enable radar for them to preserve
 *   what they saw.
 */
interface StateV40 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

export function migrateV40toV41(state: unknown): unknown {
	const s = state as StateV40 | null | undefined
	if (!s?.earthbrowser || !Array.isArray(s.earthbrowser.visibleDatasets)) return state

	const visibleDatasets = [...s.earthbrowser.visibleDatasets]
	if (visibleDatasets.includes("precipitation") && !visibleDatasets.includes("radar")) {
		visibleDatasets.push("radar")
	}

	return {
		...s,
		earthbrowser: {
			...s.earthbrowser,
			visibleDatasets,
		},
	}
}
